import { render, staticRenderFns } from "./WishlistPage.vue?vue&type=template&id=5c367c2b&scoped=true&"
import script from "./WishlistPage.vue?vue&type=script&lang=js&"
export * from "./WishlistPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c367c2b",
  null
  
)

export default component.exports